module.exports = __webpack_public_path__ + "assets/38df61cf4b5629697804f532b20b66ca.json";